module.exports = __webpack_public_path__ + "static/media/company.69e8f330.svg";